import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-radio-inactive",
  "use": "icon-radio-inactive-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-radio-inactive\">\n<rect x=\"0.5\" y=\"0.5\" width=\"23\" height=\"23\" rx=\"11.5\" fill=\"white\" />\n<circle cx=\"12\" cy=\"12\" r=\"8\" fill=\"white\" />\n<rect x=\"0.5\" y=\"0.5\" width=\"23\" height=\"23\" rx=\"11.5\" stroke=\"#CCCCCC\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol